import Loader from 'Common/Loader';
import DataGrid, {
    Column,
    Pager,
    Paging,
    SearchPanel,
    Summary,
    TotalItem
} from 'devextreme-react/cjs/data-grid';
import CustomStore from 'devextreme/data/custom_store';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';

import {
    getAllReturnToMayaveProduct,
    generateMayaveToStoreInvoice
} from '../services/return-to-mayave-request.service';

import PdfViewerModal from 'modules/return/return-to-mayave-request/components/PdfViewerModal';
import ActionModel from './ActionModel';

const ReturnToMayaveStoreRequestList: React.FC = () => {
    const [loading, setLoading] = useState(false);
    const [permissionDetails, setPermissionDetails] = useState<string[]>([]);
    const [refreshKey, setRefreshKey] = useState(0);
    const [showPdfModal, setShowPdfModal] = useState(false);
    const [pdfData, setPdfData] = useState<string | null>(null);
    const [selectedInvoice, setSelectedInvoice] = useState<any>(null);

    const [filters] = useState({
        searchText: '',
        statusId: 0 // Set default status
    });

    useEffect(() => {
        const authUserString = localStorage.getItem('authPOSUser');
        if (authUserString) {
            const authUser = JSON.parse(authUserString);
            const permissionData = authUser?.permissions || [];
            setPermissionDetails(permissionData);
        }
    }, []);

    const handleViewPdf = async (data: any) => {
        if (!data?.voucherNo) return;

        setSelectedInvoice(data);
        setLoading(true);
        try {
            const response = await generateMayaveToStoreInvoice(data.voucherNo);
            if (response?.data) {
                setPdfData(response.data);
                setShowPdfModal(true);
            }
        } catch (error) {
            console.error("Error generating PDF:", error);
        } finally {
            setLoading(false);
        }
    };

    const dataSource = () => {
        return new CustomStore({
            load: async () => {
                try {
                    const response = await getAllReturnToMayaveProduct(filters.searchText, filters.statusId);
                    return response;
                } catch (error) {
                    console.error('Data load error:', error);
                    return { data: [], totalCount: 0 };
                }
            }
        });
    };

    const reloadDataSource = () => setRefreshKey(prev => prev + 1);

    return (
        <React.Fragment>
            {loading && <Loader />}

            <div className="page-content">
                <div className="container-fluid">
                    <Card>
                        <Card.Header className="d-flex justify-content-between align-items-center">
                            <h5 className="m-0">List of Returned Product</h5>
                        </Card.Header>
                        <Card.Body className="pt-0">
                            <DataGrid
                                dataSource={dataSource()}
                                // remoteOperations={{ groupPaging: true }}
                                keyExpr="id"
                                showRowLines
                                showBorders
                                key={refreshKey}
                                columnAutoWidth
                                onContentReady={(e) => {
                                    const hasData = e.component.totalCount() > 0;
                                    e.component.option("pager.visible", hasData);
                                    e.component.option("paging.visible", hasData);
                                }}
                            >
                                <Pager
                                allowedPageSizes={[10, 25, 50, 100]}
                                    showPageSizeSelector
                                    showNavigationButtons
                                    displayMode="full"
                                    showInfo
                                />
                                <Summary>
                                    <TotalItem
                                    // column="voucherNo"
                                    // summaryType="count"
                                    // displayFormat="Total: {0}"
                                    />
                                </Summary>
                                <Paging defaultPageSize={10} />
                                <SearchPanel visible width={240} placeholder="Search..." />
                                <Column
                                    dataField="action"
                                    caption="Action"
                                    cssClass="text-start"
                                    cellRender={({ data }) => (
                                        <ActionModel
                                            reloadDataSource={reloadDataSource}
                                            selectedId={String(data?.voucherNo)}
                                            status={String(data?.status)}
                                            showMayaveChallanPdf={data?.totalFinalPrice > 0}
                                        />
                                    )}
                                />
                                <Column dataField="voucherNo" defaultSortOrder="desc" caption="Voucher Number" dataType="string" />
                                <Column
                                    dataField="createdOn"
                                    caption="Date"
                                    dataType="date"
                                    format="dd/MM/yyyy"
                                />
                                <Column dataField="storeName" caption="Store Name" dataType="string" />
                                <Column dataField="totalDPPrice" format="#,##0.00" caption="Dp Price" dataType="number" />
                                <Column cssClass='text-center' format="#,##0.00" dataField="totalFinalPrice" caption="Mayave Price" dataType="number" />

                                <Column dataField="status" caption="Status" dataType="string" />

                            </DataGrid>
                        </Card.Body>
                    </Card>
                </div>
            </div>

            {/* <PdfViewerModal
                visible={showPdfModal}
                base64Data={pdfData}
                onClose={() => {
                    setShowPdfModal(false);
                    setPdfData(null);
                }}
                title={`Invoice - ${selectedInvoice?.voucherNo}`} */}
            {/* /> */}
        </React.Fragment>
    );
};

export default ReturnToMayaveStoreRequestList;